<template>
  <div class="more-categories" v-bind:class="{'wide-view': wideView}" v-if="categories.length">
    <ul>
      <li><a v-on:click.prevent="onClick(null)">All</a></li>
      <li v-for="category in categories">
        <a v-on:click.prevent="onClick(category)">{{category.name}}</a>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['categories', 'containerWidth'],
  computed: {
    wideView() {
      return this.containerWidth >= 590;
    },
  },
  methods: {
    onClick(category) {
      this.$parent.switchCategory(category);
    },
  },
};
</script>

<style lang="less" scoped>
  .more-categories {
    border-top: #dddddd 1px solid;
    ul {
      font-size: 0;
      list-style: none;
      margin: 0 0 24px 0;
      padding: 0;

      li {
        display: inline;
        font-size: 12px;
        line-height: 24px;
        cursor: pointer;
        margin-left: 12px;

        &:before {
          content: "";
          display: inline-block;
          margin-right: 3px;
          background-image: url(../assets/tag.svg);
          background-size: cover;
          height: 12px;
          width: 12px;
        }

        a {
          color: grey;
          cursor: pointer;

          &:hover {
            opacity: .6;
          }
        }
      }
    }
  }
  .more-categories.wide-view {
    ul {
      li { width: 33.3%; }
    }
  }

  .dark-theme .more-categories ul li a {
    color: lightgrey;
  }
</style>



// WEBPACK FOOTER //
// categories.vue?5ec7a1a5